import { useAtom } from '@xstate/store/react';

import {
	addNotification,
	appendTextPreview,
	clearRovoMessage,
	clearTextPreview,
	closeHer,
	herState,
	type HerNotification,
	type HerRovoMessage,
	type HerTask,
	openHer,
	removeNotification,
	setAnimating,
	setExpanded,
	setRovoMessage,
	setVoiceState,
	toggleHer,
	type HerVoiceState,
} from '../state/HerState';

export const useHerStore = (): {
	// State
	isHerActive: boolean;
	voiceState: HerVoiceState;
	isExpanded: boolean;
	isAnimating: boolean;
	contentId: string | null;
	contentType: string;
	cloudID: string;
	textPreview: string;
	tasks: Record<string, HerTask>;
	notifications: Record<string, HerNotification>;
	rovoMessage: HerRovoMessage | null;
	// Actions
	toggleHer: (contentId?: string, cloudID?: string, contentType?: string) => void;
	openHer: (contentId?: string, cloudID?: string, contentType?: string) => void;
	closeHer: () => void;
	setExpanded: (expanded: boolean) => void;
	setAnimating: (animating: boolean) => void;
	setVoiceState: (voiceState: HerVoiceState) => void;
	appendTextPreview: (text: string) => void;
	clearTextPreview: () => void;
	addNotification: (notification: HerNotification) => void;
	removeNotification: (id: string) => void;
	setRovoMessage: (message: HerRovoMessage) => void;
	clearRovoMessage: () => void;
} => {
	const state = useAtom(herState);

	return {
		// State
		isHerActive: state.isHerActive,
		voiceState: state.voiceState,
		isExpanded: state.isExpanded,
		isAnimating: state.isAnimating,
		contentId: state.contentId,
		contentType: state.contentType,
		cloudID: state.cloudID,
		textPreview: state.textPreview,
		tasks: state.tasks,
		notifications: state.notifications,
		rovoMessage: state.rovoMessage,

		// Actions
		toggleHer,
		openHer,
		closeHer,
		setExpanded,
		setAnimating,
		setVoiceState,
		appendTextPreview,
		clearTextPreview,
		addNotification,
		removeNotification,
		setRovoMessage,
		clearRovoMessage,
	};
};
